import React from 'react'
import './Cart.css'
import {AiOutlineCloseCircle} from 'react-icons/ai'
import {BsArrowRight} from 'react-icons/bs'
import {Link} from 'react-router-dom'


const Cart = ({cart, setCart}) => {

  const increaseqlty = (shopProducts) =>{
    const available = cart.find((x)=>{
      return x.id === shopProducts.id
    })
    setCart(cart.map((curElm)=>{
      return curElm.id === shopProducts.id? {...available, qty : available.qty + 1} : curElm
    }))
  }

  const decreaseqlty = (shopProducts) =>{
    const available = cart.find((x)=>{
      return x.id === shopProducts.id
    })
    setCart(cart.map((curElm)=>{
      return curElm.id === shopProducts.id? {...available, qty : available.qty - 1} : curElm
    }))
  }

  const remove = (shopProducts) =>{
    const available = cart.find((x)=>{
      return x.id === shopProducts.id
    })
    if (available.qty > 0) {
      setCart(cart.filter((x)=>{
        return x.id !== shopProducts.id
      }))
    }
  }

  const totalPrice = cart.reduce((price, item)=> price +item.qty* item.price, 0)
  return (
    <>
    <div className='cartcontainer'>
      {
        cart.length === 0 &&
        <div className='emptycart'>
          <h2 className='empty'>Cart is Empty</h2>
          <Link to='/shop' className='link'>Shop Now <BsArrowRight/> </Link>

        </div>
      }
      <div className='content'>
        {
          cart.map((curElm) =>{
            return(
              <div className='cart_item' key={curElm.id}>
                <div className='imgbox'>
                  <img src={curElm.Img} alt={curElm.Cat}/>
                </div>
                <div className='detail'>
                  <div className='info'>
                    <h4>{curElm.Cat}</h4>
                    <p>More than just a brand</p>
                    <h3>{curElm.Price}</h3>
                    <div className='quality'>
                        <button className='increaseqlty' onClick={()=>increaseqlty(curElm)}>+</button>
                        <input type='text' value={curElm.qty}></input>
                        <button className='decreaseqlty' onClick={()=>decreaseqlty(curElm)}>-</button>
                    </div>
                    <h4 className='sub'>Sub total: ${curElm.Price} * {curElm.qty}</h4>

                  </div>
                  <div className='close'>
                    <button onClick={()=>remove(curElm)}> <AiOutlineCloseCircle/></button>
                  </div>
                </div>

              </div>
            )
          })
        }
        
      </div>
      {
        cart.length > 0 &&
        <>
          <h2 className='tp'>total:${totalPrice}</h2>
          <button className='checkout'>Checkout</button>
        </>
      }
      

    </div>
    </>
  )
}

export default Cart
